module.exports = {"420704001":"凤凰街道","420704002":"古楼街道","420704003":"西山街道","420704100":"泽林镇","420704101":"杜山镇","420704102":"新庙镇","420704103":"碧石镇","420704104":"汀祖镇","420704105":"燕矶镇","420704106":"杨叶镇","420704107":"花湖镇","420704108":"长港镇","420704200":"沙窝乡","420704400":"鄂州经济开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/420704.json
// module id = 1749
// module chunks = 0